/**
 *
 * @page 用户中心/我的方案/项目管理
 *
 **/

import {
    Space,
    Button,
    Empty,
    Spin,
    Modal,
    message,
    Input,
    Pagination,
    Row,
    Col,
    Form,
    Dropdown,
    Select,
    Table,
    Menu,
} from 'antd';
import SvgIcon from '&/components/SvgIcon';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { driver } from 'driver.js';
import { useRouterTarget, useStoreState } from '&/utils/customHooks';
import { useLocation } from 'react-router-dom';
import ProjectCard4B from './ProjectCard4B';
import BuyService from '&/components/ProjectSpace/BuyService';
import quickStartGuide from '&/store/quickStartGuide';
import { Select as AntSelect } from '&/components/AntdEncapsulation';
import {
    queryProductList,
    removeProject,
    renameProject,
    exitProject,
} from '@/api/personCenter/projectSpace';
import {
    getOrganizationList,
    memberList,
} from '@/api/personCenter/organization';
import BasePageWrap from '&/components/ResourceLib/BasePageWrap';
import BaseModal from '&/components/BaseModal';
import OperationGuidance from '&/components/ProjectSpace/OperationGuidance';
import { getSMSVerificationCode } from '&/api/Dialogs/signUpDlg';
import { formatPhone } from '&/utils/common';
import './ProjectManage.scss';
import { useEffect, useRef } from 'react';
import 'driver.js/dist/driver.css';

function ProjectManage() {
    const createBtnRef = useRef();
    const appStore = useStoreState('appStore'),
        { organization = {} } = appStore;

    const location = useLocation();
    const SEARCH = new URLSearchParams(location.search);
    const initStatus = SEARCH.get('status');
    const [isLoading, setIsLoading] = useState(false);
    const [result, setResult] = useState({
        list: [],
        nums: { count_num: 0, expire_num: 0 },
        total: 0,
        gratisProjectNum: '5',
    });
    const [projectLayout, setProjectLayout] = useState(
        appStore.projectLayoutIcon
    );
    const [queryForm, setQueryForm] = useState({
        isPersonal: 1,
        status: initStatus ? +initStatus : initStatus,
        date: [],
        tab: 0,
        sort: +localStorage.getItem('dateSortType') || 1, // 1/2/3  如果是0会出错
        page: 1,
        pageNum: 12,
        entId: undefined,
    });

    useEffect(() => {
        getList();
    }, [queryForm]);

    const isFirst = useRef(true);

    function getList() {
        setIsLoading(true);
        queryProductList(queryForm)
            .then(({ data }) => {
                setResult({
                    list: data.list,
                    nums: data.nums,
                    total: data.page.totalList - 0,
                    gratisProjectNum: data.gratisProjectNum,
                });

                if (isFirst.current === false) return;
                isFirst.current = false;
                const { guidance } = data;
                if (guidance === 0 || guidance === 1) {
                    showOperationGuidanceModal();
                }
            })
            .catch(() => {
                setResult({
                    list: [],
                    nums: { count_num: 0, expire_num: 0 },
                    total: 0,
                    gratisProjectNum: '5',
                });
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    const handlePageChange = (page, pageNum) => {
        setQueryForm(prev => ({ ...prev, page, pageNum }));
    };

    const onParamChange = (val, key) => {
        setQueryForm(prev => ({ ...prev, [key]: val, page: 1 }));
    };

    const { Item } = Form;

    useEffect(() => {
        getOrganizations();
        let driverObj = null;
        setTimeout(() => {
            quickStartGuide
                .queryGuidance('projectCreate')
                .then(projectCreate => {
                    if (+projectCreate !== 0) return;
                    driverObj = driver({
                        disableActiveInteraction: true,
                        allowClose: false,
                        steps: [
                            {
                                element: createBtnRef.current,
                                popover: {
                                    title: intl.get(
                                        'quickStartGuidance.projectCreate.title'
                                    ),
                                    description: intl.get(
                                        'quickStartGuidance.projectCreate.description'
                                    ),
                                    side: 'bottom',
                                    align: 'end',
                                    doneBtnText: intl.get(
                                        'quickStartGuidance.button.done'
                                    ),
                                    onPopoverRender: dom => {
                                        const { previousButton } = dom;
                                        previousButton.style.display = 'none';
                                    },
                                    onNextClick: () => {
                                        quickStartGuide.setGuidanceStatus(
                                            'projectCreate',
                                            2
                                        );
                                        driverObj.destroy();
                                    },
                                },
                            },
                        ],
                    });
                    driverObj.drive();
                });
        });
        return () => {
            if (driverObj) {
                driverObj.destroy();
                driverObj = null;
            }
        };
    }, []);

    const [organizationOptions, setOrganizationOptions] = useState([]);

    function getOrganizations() {
        getOrganizationList().then(({ data }) => {
            const { branchId } = organization;
            const opts = [];
            for (const el of data) {
                if (branchId && branchId !== +el.id) continue;
                opts.push({
                    value: el.id,
                    label: el.name,
                });
            }

            setOrganizationOptions(opts);
        });
    }

    const organizationsItem = (
        <Item label="分公司">
            <AntSelect
                options={organizationOptions}
                value={queryForm.entId}
                placeholder="请选择"
                style={{ width: '10rem' }}
                onChange={e => onParamChange(e, 'entId')}
            />
        </Item>
    );

    const [keyWord, setKeyWord] = useState(queryForm.keyWord);

    const search = () => {
        if (keyWord === queryForm.keyWord) return;
        onParamChange(keyWord, 'keyWord');
    };

    const keyWordItem = (
        <Item label="项目名称">
            <Input
                allowClear
                prefix={
                    <i
                        className="icon-search filled"
                        style={{ fontSize: '0.75rem' }}
                    />
                }
                style={{
                    width: '10rem',
                }}
                value={keyWord}
                placeholder="输入项目名称"
                onPressEnter={search}
                onBlur={search}
                onChange={e => void setKeyWord(e.target.value)}></Input>
        </Item>
    );

    const scope = [
        {
            label: intl.get('userCenter.allProject'),
            value: 0,
        },
        {
            label: intl.get('userCenter.createdProject'),
            value: 1,
        },
        {
            label: intl.get('userCenter.participantProject'),
            value: 2,
        },
    ];
    const scopeItem = (
        <Item label="查看范围">
            <AntSelect
                options={scope}
                value={queryForm.tab}
                style={{ width: '10rem' }}
                onChange={e => onParamChange(e, 'tab')}
            />
        </Item>
    );

    const [creator, setCreator] = useState();
    const [creatorList, setCreatorList] = useState([]);

    const handleSelectCreator = value => {
        setCreator(value);
        onParamChange(value, 'creator');
    };

    useEffect(() => {
        if (queryForm.entId) {
            memberList({ entId: queryForm.entId }).then(res => {
                let list = res?.data?.map(v => ({
                    value: v?.userId,
                    label: v?.username,
                }));
                setCreatorList(list || []);
            });
        }
    }, [queryForm.entId]);

    const creatorItem = (
        <Item label="创建人">
            <AntSelect
                options={creatorList}
                value={creator}
                placeholder="请选择"
                style={{ width: '10rem' }}
                allowClear
                onChange={e => void handleSelectCreator(e)}
            />
        </Item>
    );

    const statusList = [
        {
            label: '全部',
            value: null,
        },
        {
            label: '未开始',
            value: 0,
        },
        {
            label: '施工中',
            value: 1,
        },
        {
            label: '待验收',
            value: 2,
        },
        {
            label: '验收通过',
            value: 3,
        },
        {
            label: '已延期',
            value: 4,
        },
    ];

    const statusItem = (
        <Item label="项目状态">
            <AntSelect
                style={{ width: '10rem' }}
                options={statusList}
                value={queryForm.status}
                onChange={e => onParamChange(e, 'status')}
            />
        </Item>
    );

    const sortOptions = [
        {
            label: '按整体进度排序',
            value: 1,
        },
        {
            label: '按延期天数排序',
            value: 2,
        },
        {
            label: '按施工倒计时排序',
            value: 3,
        },
    ];

    function onSelectSort(e) {
        localStorage.setItem('dateSortType', e);
        onParamChange(e, 'sort');
    }

    const sortSelect = (
        <Select
            className="sort-select"
            value={queryForm.sort}
            options={sortOptions}
            onChange={e => onSelectSort(e)}
            suffixIcon={<i className="icon-arrow-down outlined" />}
            bordered={false}
        />
    );

    const onTabChange = e => {
        const { code } = e;
        if (code === queryForm.isPersonal) return;
        setKeyWord();
        setCreator();
        const NEXT = {
            entId: [undefined, organizationOptions[0]?.value][code - 1],
            isPersonal: code,
            sort: queryForm.sort,
            tab: 0,
            page: 1,
            pageNum: 12,
            status: null,
            date: [],
        };
        setQueryForm(NEXT);
    };

    const targetPage = useRouterTarget();

    const targetDetail = ({ id, div, status }) => {
        const PATHS = ['project-detail', 'scheme-detail'];
        targetPage({
            pathname: `/user-center/project-space/${PATHS[div - 1]}`,
            search: {
                id,
            },
            state: {
                projectStatus: status,
            },
        });
    };

    const [visible, setVisible] = useState(false);
    const [formData, setFormData] = useState({});

    const initType = useRef();

    function toPay(info) {
        projectType.current = info.div;
        setFormData(info);
        initType.current = 'unpaid';
        setVisible(true);
    }

    const projectType = useRef(1);
    const createProject = (type = 1) => {
        setFormData({});
        initType.current = 'form';
        projectType.current = type;
        setVisible(true);
    };

    const btnGroup = (size = 'middle') => (
        <Space className="btns">
            {/*<Button type="primary" onClick={() => createProject()} size={size}>
                 {intl.get('projectSpace.createDesign')}
             </Button>*/}
            <Button
                type="primary"
                icon={
                    <SvgIcon
                        className="edit-icon"
                        iconName="Icon-Add-Floor-Paln"
                    />
                }
                size={size}
                onClick={() => createProject(2)}>
                {intl.get('projectSpace.synergyDesignBusiness')}
            </Button>
        </Space>
    );

    const [delVisible, setDelVisible] = useState(false);
    const [delLoading, setdelLoading] = useState(false);
    const [delDisabled, setdelDisabled] = useState(false);
    const [isClicked, setisClicked] = useState(false); // 是否已经点击发送
    const [count, setcount] = useState(60); // 多少秒后可以再次发送
    const { mobile } = appStore.userInfo;
    const [code, setCode] = useState();

    useEffect(() => {
        setdelDisabled(!(code?.length === 6));
    }, [code]);

    const onDelCancel = () => {
        formRef.resetFields();
        setCode('');
        setDelVisible(false);
    };

    // 发送验证码
    const sendCode = async () => {
        await getSMSVerificationCode({
            mobile,
            type: 'PROJECT',
        });
        setisClicked(true);
        let time = count;
        const timmer = setInterval(() => {
            time--;
            setcount(time);
            if (time !== 0) return;
            clearInterval(timmer);
            setcount(60);
            setisClicked(false);
        }, 1e3);
    };

    const currentDel = useRef();
    const openRemoveModal = item => {
        currentDel.current = item;
        setDelVisible(true);
    };

    async function onRemove() {
        if (!/^\d{6}$/.test(code)) {
            message.warning('验证码格式错误');
            return;
        }
        setdelLoading(true);
        const isNeedResetParam = queryForm.page > 1 && result.list.length < 2;
        try {
            const { msg } = await removeProject({
                projectId: currentDel.current.id,
                code,
                mobile,
            });
            onDelCancel();
            message.success(msg);
            isNeedResetParam
                ? setQueryForm(prev => ({ ...prev, page: --prev.page }))
                : getList();
        } finally {
            setdelLoading(false);
        }
    }

    function onExit(item) {
        const isNeedResetParam = queryForm.page > 1 && result.list.length < 2;
        const modal = Modal.confirm({
            title: intl.get('base.warning'),
            icon: <ExclamationCircleOutlined />,
            content: `是否退出项目 “${item.name}”？`,
            okText: intl.get('base.confirm'),
            cancelText: intl.get('base.cancel'),
            okButtonProps: { loading: false },
            centered: true,
            onOk: async () => {
                modal.update({ okButtonProps: { loading: true } });
                try {
                    const { msg } = await exitProject({
                        projectId: item.id,
                    });
                    message.success(msg);
                    isNeedResetParam
                        ? setQueryForm(prev => ({ ...prev, page: --prev.page }))
                        : getList();
                } finally {
                    modal.update({ okButtonProps: { loading: false } });
                }
            },
        });
    }

    const [renameVisible, setRenameVisible] = useState(false);
    const [formRef] = Form.useForm();

    function onRename(item) {
        formRef.setFieldsValue({
            projectId: item.id,
            name: item.name,
        });
        setRenameVisible(true);
    }

    const onCancel = () => {
        formRef.resetFields();
        setRenameVisible(false);
    };

    const [okLoading, setOkLoading] = useState(false);

    function onSubmitName(values) {
        setOkLoading(true);
        renameProject({
            ...values,
        })
            .then(({ msg }) => {
                message.success(msg);
                const idx = result.list.findIndex(
                    e => e.id === values.projectId
                );
                setResult(prev => {
                    const next = { ...prev };
                    next.list[idx].name = values.name;
                    return next;
                });
                setRenameVisible(false);
            })
            .finally(() => {
                setOkLoading(false);
            });
    }

    const OperationGuidanceRef = useRef(null);
    const showOperationGuidanceModal = () => {
        OperationGuidanceRef.current.show();
    };

    const TABS = [
        {
            name: '我的项目',
            code: 1,
        },
    ];

    // 是所在单位的管理员
    if (organization.roleFlag === 'admin') {
        TABS.push({
            name: '团队项目',
            code: 2,
        });
    }

    const changeLayout = () => {
        setProjectLayout(val => {
            if (val === 'Icon-List-List') {
                appStore.changeProjectLayoutIcon('Icon-List-Thumb');
                return 'Icon-List-Thumb';
            } else {
                appStore.changeProjectLayoutIcon('Icon-List-List');
                return 'Icon-List-List';
            }
        });
    };

    const STATUS_DICT = [
        {
            type: 'default',
            icon: 'icon-Info-Circle',
            name: '未开始',
        },
        {
            type: 'warning',
            icon: 'icon-Info-Circle',
            name: '施工中',
        },
        {
            type: 'danger',
            icon: 'icon-warning-copy',
            name: '待验收',
        },
        {
            type: 'success',
            icon: 'icon-Confirm',
            name: '已竣工',
        },
        {
            type: 'danger',
            icon: 'icon-warning-copy',
            name: '验收不通过',
        },
        {
            type: 'default',
            icon: 'icon-Info-Circle',
            name: '未发布',
        },
    ];

    const renderStatus = (type, name, icon) => (
        <span className={`project-status status--${type}`}>
            <i className={`filled ${icon}`}></i> {name}
        </span>
    );

    const statusEl = (status, record) =>
        record.isDelay === '1'
            ? renderStatus('danger', '已延期', 'icon-warning-copy')
            : renderStatus(
                  STATUS_DICT[status]?.type,
                  STATUS_DICT[status]?.name,
                  STATUS_DICT[status]?.icon
              );

    const createInfoStatus = (text, record) => {
        if (!record.status) return;
        let btn = null;
        if (+record.status === 3)
            btn = (
                <div className="info-status">
                    <div className="blue-btn" onClick={() => toPay?.(record)}>
                        待支付
                    </div>
                </div>
            );
        else if (+record.status === 4)
            return (
                <div className="info-status">
                    <div className="expired description">已过期</div>
                    <div className="blue-btn" onClick={() => toPay?.(record)}>
                        重新下单
                    </div>
                </div>
            );
        else if (+record.status === 5 && +record.isCreate === 1)
            btn = (
                <div className="info-status">
                    <div className="expiringSoon description">即将到期</div>
                    <div className="blue-btn" onClick={() => toPay?.(record)}>
                        续费
                    </div>
                </div>
            );

        return btn;
    };

    const handleClickMenu = (key, record) => {
        [onRename, openRemoveModal, onExit][key](record);
    };

    const menu = record => (
        <Menu onClick={({ key }) => handleClickMenu(key, record)}>
            <Menu.Item key={0} disabled={[2, 3].includes(record.isCreate)}>
                {intl.get('base.rename')}
            </Menu.Item>
            <Menu.Item
                disabled={
                    [2, 3].includes(record.isCreate) || record.status === '3'
                }
                key={1}>
                解散项目
            </Menu.Item>
            <Menu.Item disabled={[1, 3].includes(record.isCreate)} key={2}>
                退出项目
            </Menu.Item>
        </Menu>
    );

    const columns = [
        {
            title: '序号',
            dataIndex: 'index',
            width: 70,
            align: 'center',
            key: 'index',
        },
        {
            title: '项目名称',
            dataIndex: 'name',
            key: 'name',
            width: 250,
            ellipsis: true,
            onCell: record => ({
                onClick: () => {
                    targetDetail(record);
                },
            }),
            render: (text, record) => {
                return (
                    <div className="title-column" key={record.id + '__title'}>
                        <img
                            className="title-image"
                            src={
                                record.image ||
                                require('&/assets/img/userCenter/lbdefault.png')
                                    .default
                            }
                        />
                        <span title={text} className="title-text">
                            {text}
                        </span>
                    </div>
                );
            },
        },
        {
            title: '工期',
            dataIndex: 'timeLine',
            key: 'timeLine',
            width: 180,
        },
        {
            title: '整体进度',
            dataIndex: 'isFinish',
            key: 'isFinish',
            width: 80,
            align: 'right',
        },
        {
            title: '延期天数（天）',
            dataIndex: 'duty',
            key: 'duty',
            width: 120,
            align: 'right',
        },
        {
            title: '施工倒计时（天）',
            dataIndex: 'reciprocal',
            key: 'reciprocal',
            width: 130,
            align: 'right',
        },
        {
            title: '施工状态',
            dataIndex: 'checkStatus',
            key: 'checkStatus',
            width: 90,
            align: 'center',
            render: statusEl,
        },
        {
            title: '到期时间',
            dataIndex: 'expireDateMax',
            key: 'expireDateMax',
            width: 200,
            render: (text, record) => (
                <div className="expired-column" key={record.id + '__expired'}>
                    <div className="expired-time">{text}</div>
                    {createInfoStatus(text, record)}
                </div>
            ),
        },
        {
            title: '操作',
            key: 'opt',
            width: 90,
            render: (text, record) => (
                <div className="opt-column" key={record.id + '__opt'}>
                    <div
                        className="blue-btn"
                        onClick={() => {
                            targetDetail(record);
                        }}>
                        详情
                    </div>
                    <Dropdown overlay={menu(record)} arrow={false}>
                        <div className="blue-btn">更多</div>
                    </Dropdown>
                </div>
            ),
        },
    ];

    return (
        <>
            <BasePageWrap
                className="project-space"
                type="card"
                tabs={TABS}
                headerRight={
                    <div className="header-right" ref={createBtnRef}>
                        {btnGroup()}
                    </div>
                }
                onTabChange={onTabChange}>
                <Spin spinning={isLoading}>
                    <div className="params-wrap">
                        <Form layout="inline">
                            {queryForm.isPersonal === 1 && scopeItem}
                            {queryForm.isPersonal === 2 && creatorItem}
                            {queryForm.isPersonal === 2 && organizationsItem}
                            {statusItem}
                            {keyWordItem}
                        </Form>
                        <div className="right-content-wrap">
                            {sortSelect}
                            <SvgIcon
                                className="change-layout"
                                iconName={projectLayout}
                                onClick={changeLayout}
                            />
                        </div>
                    </div>

                    {!result.total ? (
                        <Empty
                            image={
                                require('&/assets/img/userCenter/emptyydata-object.png')
                                    .default
                            }
                            imageStyle={{
                                height: 160,
                                marginTop: '10%',
                            }}
                            description={
                                <>
                                    <div className="hint-message">暂无项目</div>
                                </>
                            }>
                            {queryForm.tab < 2 && btnGroup('large')}
                        </Empty>
                    ) : (
                        <>
                            <div className="project-detail-content">
                                {projectLayout === 'Icon-List-List' ? (
                                    <Row gutter={[24, 24]}>
                                        {result.list.map(e => (
                                            <Col span={8} key={e.id}>
                                                <ProjectCard4B
                                                    source={e}
                                                    remove={openRemoveModal}
                                                    rename={onRename}
                                                    onExit={onExit}
                                                    clickName={() =>
                                                        targetDetail(e)
                                                    }
                                                    toPay={toPay}
                                                    sortType={queryForm.sort}
                                                />
                                            </Col>
                                        ))}
                                    </Row>
                                ) : (
                                    <Table
                                        className="project-table"
                                        bordered
                                        pagination={false}
                                        dataSource={result.list.map(
                                            (item, index) => ({
                                                ...item,
                                                key: item.id,
                                                index: index + 1,
                                                timeLine: `${item.timeAt} - ${item.timeEnd}`,
                                                duty:
                                                    item.schedule &&
                                                    item.schedule.duty !== null
                                                        ? item.schedule.duty
                                                        : '-',
                                                isFinish:
                                                    item.schedule &&
                                                    item.schedule.isFinish !==
                                                        null
                                                        ? item.schedule
                                                              .isFinish + '%'
                                                        : '-',
                                                reciprocal:
                                                    item.schedule &&
                                                    item.schedule.reciprocal !==
                                                        null
                                                        ? item.schedule
                                                              .reciprocal
                                                        : '-',
                                            })
                                        )}
                                        columns={columns}
                                    />
                                )}
                            </div>
                            <Pagination
                                size="small"
                                current={queryForm.page}
                                onChange={handlePageChange}
                                total={result.total}
                                pageSize={queryForm.pageNum}
                                showTotal={total =>
                                    intl.get('base.total', { total })
                                }
                            />
                        </>
                    )}
                </Spin>
            </BasePageWrap>
            {visible && (
                <BuyService
                    visible={visible}
                    initData={formData}
                    div={projectType.current}
                    initState={initType.current}
                    setVisible={setVisible}
                    gratisProjectNum={result.gratisProjectNum}
                    refesh={getList}></BuyService>
            )}
            <OperationGuidance ref={OperationGuidanceRef} queryList={getList} />
            <BaseModal
                title={'重命名'}
                visible={renameVisible}
                onOk={formRef.submit}
                width="20rem"
                forceRender
                okButtonProps={{
                    loading: okLoading,
                }}
                onCancel={onCancel}>
                <Form form={formRef} onFinish={onSubmitName}>
                    <Item
                        name="name"
                        validateFirst
                        rules={[
                            {
                                required: true,
                                message: '请输入项目名称',
                            },
                            {
                                validator: async (rule, value) => {
                                    if (!value) return;
                                    const val = value.replace(
                                        /[\u4e00-\u9fa5]/g,
                                        'aa'
                                    );
                                    if (val.length < 31) {
                                        return Promise.resolve();
                                    }
                                    throw new Error('最多输入30个字符');
                                },
                            },
                        ]}>
                        <Input allowClear></Input>
                    </Item>
                    <Item name="projectId" hidden>
                        <Input></Input>
                    </Item>
                </Form>
            </BaseModal>

            <BaseModal
                title="解散项目"
                okText="确定解散"
                visible={delVisible}
                onCancel={onDelCancel}
                forceRender
                onOk={onRemove}
                okButtonProps={{
                    loading: delLoading,
                    disabled: delDisabled,
                    ghost: delDisabled,
                }}>
                <div className="form-group warn-block">
                    <img
                        src={
                            require('&/assets/img/userCenter/warnimg.png')
                                .default
                        }
                        className="warn-image"
                    />
                    <div className="warn-block__msg">是否确定解散该项目？</div>
                    <div className="warn-block__status">
                        该项目
                        {+currentDel.current?.status === 4
                            ? '已到期'
                            : '还未到期'}
                    </div>
                </div>
                <div className="form-group send-msg-block">
                    <div className="current-phone">
                        当前手机号{formatPhone(mobile)}
                    </div>
                    <div className="send-msg-group">
                        <Input
                            value={code}
                            onChange={e => setCode(e.target.value)}
                            maxLength={6}
                            placeholder="请输入短信验证码"
                        />
                        <Button
                            disabled={isClicked}
                            type="text"
                            onClick={sendCode}
                            className="auth-code-btn">
                            {isClicked
                                ? intl.get('signUpSignIn.interval', {
                                      count,
                                  })
                                : '获取短信验证码'}
                        </Button>
                    </div>
                </div>
            </BaseModal>
        </>
    );
}

export default ProjectManage;
